import React, { Fragment } from 'react';
import { withApollo } from 'react-apollo';

// Render Children component and pass props down to it
function ConnectApollo({ children, ...restProps }) {
  const childrenWithProps = React.Children.map(children, child => {
    return React.cloneElement(child, { ...restProps });
  });
  return <Fragment>{childrenWithProps}</Fragment>;
}

export default withApollo(ConnectApollo);
